var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77772 3.67409C10.4355 3.23458 11.2089 3 12 3C13.0609 3 14.0783 3.42143 14.8284 4.17157C15.5786 4.92172 16 5.9391 16 6.99996C16 7.7911 15.7654 8.56446 15.3259 9.22226C14.8864 9.88006 14.2616 10.3928 13.5307 10.6955C12.7998 10.9983 11.9956 11.0775 11.2196 10.9231C10.4437 10.7688 9.731 10.3878 9.17158 9.8284C8.61217 9.26899 8.2312 8.55626 8.07686 7.78033C7.92252 7.00441 8.00174 6.20015 8.30449 5.46924C8.60724 4.73833 9.11993 4.11362 9.77772 3.67409Z",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9938 14.0002V14.0003L12.0055 14.0002C14.119 13.9887 16.1658 14.5608 17.8353 15.6118L17.8533 15.6232L17.8718 15.6337C18.4921 15.9883 18.9975 16.4464 19.3619 16.9655C19.7139 17.4672 19.9273 18.0153 19.9995 18.5725C19.9941 18.7666 19.9428 18.964 19.8412 19.1544C19.7325 19.3582 19.5661 19.5537 19.3419 19.7203C18.7813 20.1053 18.1157 20.3857 17.392 20.5325C13.8308 21.1558 10.1556 21.1558 6.59443 20.5325C5.87213 20.386 5.20771 20.1064 4.64779 19.7226C4.4271 19.5553 4.26338 19.3602 4.15641 19.1571L3.27166 19.6232L4.15641 19.1571C4.05552 18.9656 4.00491 18.7672 4.00034 18.5719C4.06995 18.0144 4.28212 17.4656 4.63444 16.9637C4.99839 16.4451 5.50428 15.9879 6.12562 15.6352L6.14577 15.6238L6.16538 15.6114C7.83361 14.5593 9.88045 13.9871 11.9938 14.0002Z",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.9f500fa5deff443d4aab30bb245c6f84.svg";
export { ForwardRef as ReactComponent };